export default {"src":"/_next/static/media/update.db08ec25.svg","height":125,"width":169,"blurWidth":0,"blurHeight":0};